if (!customElements.get('carousel-slider')) {
    customElements.define('carousel-slider', class CarouselSlider extends HTMLElement {
        constructor() {
            super();
            this.autoRotateInterval = null;
        }

        connectedCallback() {
            this.carousel = this.querySelector('.grid-carousel');
            this.initialize();
        }

        initialize() {
            this.carousel.style.display = 'block';
            this.flickity = new Flickity(this.carousel, {
                cellAlign: 'left',
                groupCells: false, //one product at a time
                contain: true,
                resize: true,
                draggable: true,
                prevNextButtons: false,
                fade: false,
                cellSelector: '.grid-item',
                initialIndex: 0,
                pageDots: false,
                wrapAround: true, // Ensure it loops back to the beginning
                accessibility: false,
                watchCSS: true,
            });

            this.flickity.on('change', (index) => {
                const event = new CustomEvent('slider:slide-change', {
                    detail: {
                        id: this.getAttribute('id'),
                        index,
                    },
                });
                document.dispatchEvent(event);
            });

            this.startAutoRotate();
        }

        startAutoRotate() {
            this.autoRotateInterval = setInterval(() => {
                this.flickity.next();
            }, 2500); // Change slide every 2.5 seconds
        }

        stopAutoRotate() {
            if (this.autoRotateInterval) {
                clearInterval(this.autoRotateInterval);
                this.autoRotateInterval = null;
            }
        }
    });
}

if (!customElements.get('carousel-navigation')) {
    customElements.define('carousel-navigation', class CarouselNavigation extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.init();
        }

        init(retry = 1, maxRetry = 3) {
            if (retry === maxRetry) {
                return;
            }

            const id = this.getAttribute('for');
            this.carouselComponent = document.querySelector(`#${id}`);
            this.wrap = this.dataset.wrap === 'true';

            if ((!this.carouselComponent || !this.carouselComponent.flickity)) {
                setTimeout(() => {
                    this.init(retry + 1);
                }, 350);
                return;
            }

            this.flickity = this.carouselComponent.flickity;
            this.buttonPrev = this.querySelector('.js-prev');
            this.buttonNext = this.querySelector('.js-next');

            this.buttonPrev.addEventListener('click', (event) => {
                event.preventDefault();
                this.flickity.previous();
            });

            this.buttonNext.addEventListener('click', (event) => {
                event.preventDefault();
                this.flickity.next();
            });

            this.flickity.on('select', () => {
                if (this.wrap) {
                    return;
                }

                this.enableButton(this.buttonPrev);
                this.enableButton(this.buttonNext);

                if (!this.flickity.slides[this.flickity.selectedIndex - 1]) {
                    this.disableButton(this.buttonPrev);
                } else if (!this.flickity.slides[this.flickity.selectedIndex + 1]) {
                    this.disableButton(this.buttonNext);
                }
            });
        }

        enableButton(button) {
            button.classList.remove('pill-nav-item-disabled');
            button.classList.remove('focus-none');
            button.setAttribute('aria-disabled', 'false');
        }

        disableButton(button) {
            button.classList.add('pill-nav-item-disabled');
            button.classList.add('focus-none');
            button.setAttribute('aria-disabled', 'true');
        }
    });
}
